import { formatDate } from '@angular/common';
import { BundleListItem } from '../../../../../../pages/admin-dashboard/promotions/bundles-managment/bundles.model';
import { BundleTableRow } from './bundle-table-component.model';

function formatDiscount(bundle: BundleListItem, isArabic: boolean): string {
  const isPercentage = bundle.discountType === 'PERCENTAGE';
  if (isArabic) {
    const type = isPercentage ? 'نسبة مئوية' : 'مبلغ ثابت';
    return `${type} - ${bundle.discountValue}${isPercentage ? '%' : ' ج.م'}`;
  }
  const type = isPercentage ? 'Percentage' : 'Fixed Amount';
  return `${type} - ${bundle.discountValue}${isPercentage ? '%' : ' EGP'}`;
}

function formatStatus(bundle: BundleListItem) {
  switch (bundle.status?.id) {
    case 1:
      return { titleEn: 'Active', titleAr: 'نشط' };
    case 2:
      return { titleEn: 'Inactive', titleAr: 'غير نشط' };
    case 3:
      return { titleEn: 'Expired', titleAr: 'منتهي' };
    default:
      return { titleEn: bundle.status?.titleEn ?? '—', titleAr: bundle.status?.titleAr ?? '—' };
  }
}

function toBundleTableRow(bundle: BundleListItem, isArabic: boolean, locale: string): BundleTableRow {
  const currency = isArabic ? 'ج.م' : 'EGP';
  const start = formatDate(bundle.startDate, 'mediumDate', locale);
  const end = formatDate(bundle.endDate, 'mediumDate', locale);

  return {
    id: bundle.id,
    title: (isArabic ? bundle.titleAr : bundle.titleEn) || bundle.titleEn,
    discount: formatDiscount(bundle, isArabic),
    duration: isArabic ? `من ${start} إلى ${end}` : `${start} - ${end}`,
    productCount: bundle.productCount,
    pharmacyPrice: {
      price: `${bundle.pharmacyPriceBeforeDiscount} ${currency}`,
      discount: `${bundle.pharmacyPriceAfterDiscount} ${currency}`,
    },
    status: formatStatus(bundle),
  };
}

export function toBundleTableRows(bundles: BundleListItem[], isArabic: boolean, locale: string): BundleTableRow[] {
  return bundles.map((b) => toBundleTableRow(b, isArabic, locale));
}
